<script setup>
import { onMounted, ref } from "vue";
import { appBarStore } from "@/stores/appBar";
const appBar = appBarStore();
import { permissionsStore } from "@/stores/permissions";
const permissions = permissionsStore();
const items = ref([]);

permissions.$subscribe(() => {
  buildSidebarItems();
});

onMounted(async () => {
  appBar.$reset();
  if (appBar.appRunning != "J24 Patching") {
    appBar.$patch({
      appRunning: "J24 Patching",
      type: "None",
      items: [],
      selected: "App Patches",
    });
  }
  buildSidebarItems();
});

function buildSidebarItems() {
  items.value.length = 0;
  allItems.forEach((item) => {
    if (permissions.$state["Patching-" + item.privName]) {
      items.value.push(item);
    }
  });
}

const allItems = [
  // { title: "Assets", icon: "mdi-archive", link: "AssetsBulkUploader" },
  {
    title: "Approvals",
    icon: "mdi-server",
    link: "PatchingApprovals",
    value: false,
    privName: "ApprovePatchVersions",
  },
  {
    title: "App Patches",
    icon: "mdi-server",
    link: "PatchingPatches",
    value: false,
    privName: "ApprovePatchVersions",
  },
  {
    title: "App Pipeline",
    icon: "mdi-server",
    link: "PatchngPipleline",
    value: false,
    privName: "pipeline",
  },
  {
    title: "Pipeline Status",
    icon: "mdi-server",
    link: "PipelineStatus",
    value: false,
    privName: "pipeline",
  },
  {
    title: "Unknown Versions",
    icon: "mdi-server",
    link: "PatchingUnknownVersions",
    value: false,
    privName: "pipeline",
  },
  {
    title: "Patch Usage",
    icon: "mdi-server",
    link: "PatchingUsageReport",
    value: false,
    privName: "pipeline",
  },
  {
    title: "Compliance",
    icon: "mdi-server",
    link: "PatchingComplianceReport",
    value: false,
    privName: "PatchingComplianceReport",
  },
  {
    title: "Health",
    icon: "mdi-medical-bag",
    link: "PatchingHealth",
    value: false,
    privName: "pipeline",
  },
];

// Required to make the router-view reload when user clicks the link again
// See the key value set on <router-view> below.
const randomKey = ref("");
function updateRandom() {
  randomKey.value = (Math.random() + 1).toString(36).substring(7);
}
</script>

<template>
  <v-navigation-drawer permanent width="190" theme="jigsawDark">
    <v-list>
      <div class="v-list-item">
        <v-icon class="pa-3" color="#e7541e">mdi-account-details</v-icon>
        <div class="text-h7 pa-3 cursor-default">
          <strong>Patching</strong>
        </div>
      </div>
      <template v-for="item in items" :key="item.title">
        <v-list-item
          class="sideBarListItem"
          link
          :to="{ name: item.link }"
          color="#e7541e"
          @click="updateRandom()"
        >
          <template v-slot:prepend>
            <v-icon class="mr-2">{{ item.icon }}</v-icon>
          </template>
          <v-list-item-title class="pl-n4">
            {{ item.title }}
          </v-list-item-title>
        </v-list-item>
      </template>
    </v-list>
  </v-navigation-drawer>
  <v-main>
    <v-container fluid>
      <router-view :key="randomKey" />
    </v-container>
  </v-main>
</template>

<style scoped>
.sideBarListItem :deep(.v-list-item__prepend .v-list-item__spacer) {
  width: 10px !important;
}
</style>
